module.exports = __webpack_public_path__ + "img/1494636283.d7ca24f9.jpg";